import { c as _c } from "react/compiler-runtime";
import { useEffect, useMemo, useRef } from "react";

/**
 * Converts a callback to a ref to avoid triggering re-renders when passed as a
 * prop or avoid re-executing effects when passed as a dependency.
 *
 * @see https://github.com/radix-ui/primitives/blob/main/packages/react/use-callback-ref/src/useCallbackRef.tsx
 */
export function useCallbackRef(callback) {
  const $ = _c(3);
  const callbackRef = useRef(callback);
  let t0;
  if ($[0] !== callback) {
    t0 = () => {
      callbackRef.current = callback;
    };
    $[0] = callback;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  useEffect(t0);
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = (...t2) => {
      const args = t2;
      return callbackRef.current?.(...args);
    };
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1 as T;
}